// frontend/src/components/ui/ResendVerificationButton.tsx

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import api from '@/lib/api';
import { Button } from '@/components/ui/Button';

export function ResendVerificationButton({ email }: { email: string }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleResend = async () => {
    try {
      setIsLoading(true);
      await api.post('/auth/resend-verification', { email });
      toast.success(t('auth.verification_resent'));
    } catch {
      // api interceptor already shows the error toast
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      type="button"
      variant="secondary"
      className="w-full"
      isLoading={isLoading}
      disabled={!email}
      onClick={handleResend}
    >
      {t('auth.resend_verification')}
    </Button>
  );
}
